/* ============
 * Notifier Store
 * ============
 */

import { defineStore } from 'pinia';
import './pinia';

export const useNotifierStore = defineStore('notifier', {
  state: () => ({
    visibility: false,
    message: '',
    type: '',
    closable: false,
    name: null,
    close_name: null,
    params: {},
  }),

  actions: {
    open(data) {
      if (data.close_name && localStorage.getItem(data.close_name)) {
        return;
      }
      const app = document.getElementById('app');
      app.classList.add('sp-notif-visible');
      this.visibility = true;

      if (data.name) {
        this.name = data.name;
      }

      if (data.message) {
        this.message = data.message;
      }

      if (data.close) {
        this.closable = true;
      }

      if (data.close_name) {
        this.close_name = data.close_name;
      } else {
        this.close_name = null;
      }

      if (data.type) {
        this.type = data.type;
      } else {
        this.type = 'danger';
      }

      if (data.time) {
        setTimeout(() => {
          this.close({ name: this.name });
        }, data.time);
      }

      if (data.onClickLink) {
        setTimeout(() => {
          const linkElement = document.querySelector('#mandate-link');
          if (linkElement && !linkElement.dataset.clickBound) {
            linkElement.addEventListener('click', (event) => {
              event.preventDefault();
              data.onClickLink();
            }, { once: true });

            // Flag the element so no second listener gets attached.
            linkElement.dataset.clickBound = 'true';
          }
        }, 0);
      }

      if (data.params) {
        this.params = data.params;
      } else {
        this.params = {};
      }
    },

    close(data) {
      const app = document.getElementById('app');

      if (!data || !data.name || (this.name === data.name)) {
        this.visibility = false;
        app.classList.remove('sp-notif-visible');
        if (this.close_name && data && data.manually) {
          localStorage.setItem(this.close_name, true);
        }
      }
    },
  },
});

export default useNotifierStore;
